import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

// reducers
// import cards from './Card';
import userReducer from './Auth';
import onboardingReducer from './onboarding';
import loadingReducer from './loading';
import saversReducer from './savers';
import fundReducer from "./fund"
import cashoutReducer from "./cashout"
import transferReducer from "./transfer"
import commissionReducer from "./commission"
import agentsReducer from "./Agents"
import accLoadingReducer from "./AccLoading"
import payments from "./payments"


const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    user: userReducer,
    onboarding: onboardingReducer,
    loading: loadingReducer,
    savers: saversReducer,
    fund: fundReducer,
    cashout: cashoutReducer,
    transfer: transferReducer,
    commission: commissionReducer,
    agents: agentsReducer,
    accLoading: accLoadingReducer,
    payments
  });

export default rootReducer;
